import type { CustomFieldValidator } from '@backstage/plugin-scaffolder-react';
import type { FileSchema } from '@ipen-portal/plugin-common';
import type { FieldValidation } from '@rjsf/utils';

import { checkFileSize } from '@ipen-portal/plugin-common';

import type { FileAttachmentOutput, FileAttachmentUiOptions } from './schema';

const validateFile = ({
  output,
  schema,
  validation,
}: {
  output: FileSchema;
  schema: FileAttachmentUiOptions;
  validation: FieldValidation;
}) => {
  const { mimeType, size } = output;

  const { maxSize, mimeTypes: allowedMimeTypes } = schema ?? {};

  if (maxSize && !checkFileSize(size, maxSize)) {
    validation.addError('File size exceeds the maximum allowed size.');
  }

  if (allowedMimeTypes && !allowedMimeTypes.includes(mimeType)) {
    validation.addError('File type is not allowed.');
  }

  if (!mimeType.startsWith('image/')) return;

  const { maxHeight, maxWidth } = schema ?? {};
  const { height, width } = output;

  if (maxWidth !== undefined && width !== undefined && width > maxWidth) {
    validation.addError(
      `Image width exceeds the maximum allowed width of ${maxWidth}px.`,
    );
  }

  if (maxHeight !== undefined && height !== undefined && height > maxHeight) {
    validation.addError(
      `Image height exceeds the maximum allowed height of ${maxHeight}px.`,
    );
  }
};

export const validateFileAttachments: CustomFieldValidator<
  FileAttachmentOutput,
  FileAttachmentUiOptions
> = (output, validation, { uiSchema }) => {
  if (!output.uploadFinished) {
    validation.addError('Wait for all files to finish uploading.');
  }

  if (!uiSchema) {
    return;
  }

  output.files.forEach(output => {
    validateFile({
      output,
      schema: uiSchema['ui:options'],
      validation,
    });
  });
};
